export const isNumberUndefinedOrNull = num => {
  return num === undefined || num === null;
};

export const isNumKeyValid = e => e.key === 'Backspace' || /[0-9]/.test(Number(e.key).toString());
